import { soundService } from '../../../../services/baseSoundService/soundService';

export const FootballSoundsName = {
  bgMusic: 'bg-music',
  kick: 'kick',
  lose: 'lose',
  win: 'win',
  bet: 'bet',
};

export const FootballSoundsPath = [
  {
    src: 'audio/football/bg-music.mp3',
    name: FootballSoundsName.bgMusic,
    autoplay: false,
    html5: true,
    loop: false,
    buffer: true,
    onplay: function () {
      this._sounds[0]._node.bufferTime = 0.5; // need it for safari
    },
    onend: function () {
      soundService.play(FootballSoundsName.bgMusic);
    },
  },
  {
    src: 'audio/football/bet.mp3',
    name: FootballSoundsName.bet,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/football/win.mp3',
    name: FootballSoundsName.win,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/football/kick.mp3',
    name: FootballSoundsName.kick,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/football/lose.mp3',
    name: FootballSoundsName.lose,
    autoplay: false,
    html5: true,
  },
];
